import React from 'react';
import { Box, Grid, Flex, Heading, Text } from '@chakra-ui/react';

interface InfoItemProps {
  image?: React.ReactNode;
  title: string;
  description: string | React.ReactNode;
}

const InfoItem = ({ image, title, description }: InfoItemProps) => (
  <Flex justifyContent="center">
    <Box w="100%" maxW="lg" p={5} pt={0} textAlign="center">
      {image && image}
      <Text as="h3" fontSize={['3xl']} fontWeight="bold" mb="6">
        {title}
      </Text>
      <Text fontSize={['md']}>{description}</Text>
    </Box>
  </Flex>
);

InfoItem.defaultProps = { image: null };
interface InfoSectionProps {
  sectionTitle: string;
  infoItems: InfoItemProps[];
  numColumns: number;
}

const InfoSection = ({
  sectionTitle,
  infoItems,
  numColumns,
}: InfoSectionProps) => (
  <Box maxW="8xl" m="auto" my={['16', '20']}>
    <Heading
      width="100%"
      textAlign="center"
      fontWeight={800}
      fontSize={['2xl', '3xl', '5xl', '5xl']}
      mb={['16', '20']}
      px={['10', '16', '32']}
    >
      {sectionTitle}
    </Heading>
    <Grid
      templateColumns={[
        'repeat(1, 1fr)',
        'repeat(1, 1fr)',
        `repeat(${numColumns}, 1fr)`,
      ]}
      justifyContent="center"
      rowGap={10}
      px={[2, 9]}
    >
      {infoItems.map(({ image, title, description }) => (
        <InfoItem
          key={title}
          image={image}
          title={title}
          description={description}
        />
      ))}
    </Grid>
  </Box>
);

export default InfoSection;
